var render = function render(){var _vm=this,_c=_vm._self._c;return _c('format',{attrs:{"msg":_vm.$t('game-others'),"type-game":5,"src":require('@/assets/nav/submenu/icon_power_ball.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }